export default "__VITE_ASSET__56762004__"